/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Push_Subscription_InvalidInputs */

const en_error_push_subscription_invalid = /** @type {(inputs: Error_Push_Subscription_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser could not be set up for notifications. Turn them on again, or try another browser.`)
};

/**
* | output |
* | --- |
* | "This browser could not be set up for notifications. Turn them on again, or try another browser." |
*
* @param {Error_Push_Subscription_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_push_subscription_invalid = /** @type {((inputs?: Error_Push_Subscription_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Push_Subscription_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_push_subscription_invalid(inputs)
});